var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.1797C17 17.7841 17 17.0863 16.8278 16.5185C16.44 15.2401 15.4395 14.2397 14.1611 13.8519C13.5933 13.6797 12.8956 13.6797 11.5 13.6797H6.5C5.10444 13.6797 4.40665 13.6797 3.83886 13.8519C2.56045 14.2397 1.56004 15.2401 1.17224 16.5185C1 17.0863 1 17.7841 1 19.1797M13.5 5.67969C13.5 8.16497 11.4853 10.1797 9 10.1797C6.51472 10.1797 4.5 8.16497 4.5 5.67969C4.5 3.19441 6.51472 1.17969 9 1.17969C11.4853 1.17969 13.5 3.19441 13.5 5.67969Z",
    stroke: "#EB5B1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.3ef9efbe645f1df66f27e425520d42f3.svg";
export { ForwardRef as ReactComponent };